import 'react-hot-loader/patch';
import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import i18n from '@wix/da-i18next/pkg/presetI18nClientConfig';
import App from './components/App';
import { AppContainer } from 'react-hot-loader';
import { Router } from 'react-router-dom';
import { configureStore } from './store/configureStore';
import {
  routerSafeHistory as history,
  configureHistoryListener,
} from '@wix/da-shared-react/pkg/redux/routing/history';
import { getClientInstance } from '@wix/da-ddt';
import { XHR_BASE_PATH } from '../constants';
import Modal from 'react-modal';
import { DaAppWrapper } from '@wix/da-shared-react/pkg/DaApp';

if (window.Sentry && process.env.NODE_ENV === 'production') {
  window.Sentry.onLoad(() => {
    window.Sentry.init({
      release: window['__APP_INFO__'],
      environment: 'production',
    });
  });
}

const ddt = getClientInstance();
ddt.replayServerSideLogs(window['__DDT__']);

const initialI18n = window['__INITIAL_I18N__'];

const initialState = window['__INITIAL_STATE__'];
delete window['__INITIAL_STATE__'];
const store = configureStore(initialState);
configureHistoryListener(store);
i18n(initialI18n);
wixAxiosConfig(axios, { baseURL: XHR_BASE_PATH });

Modal.setAppElement('#root');

if (module.hot) {
  module.hot.accept('./components/App', () => {
    // eslint-disable-next-line global-require
    const AppLatest = require('./components/App').default;
    ReactDOM.hydrate(
      <AppContainer>
        <DaAppWrapper store={store}>
          <Router history={history}>
            <AppLatest />
          </Router>
        </DaAppWrapper>
      </AppContainer>,
      document.getElementById('root')
    );
  });
}
ReactDOM.hydrate(
  <DaAppWrapper store={store}>
    <Router history={history}>
      <App
        language={initialI18n.locale}
        userAgent={
          (window && window.navigator && window.navigator.userAgent) || ''
        }
      />
    </Router>
  </DaAppWrapper>,
  document.getElementById('root')
);
